var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { observable, computed, set, keys } from 'mobx';
import { fieldValidating } from './form.validators';
let FormStore = (_class = class FormStore {
  constructor(validation, fieldsToValidate) {
    _initializerDefineProperty(this, "formErrorResponse", _descriptor, this);
    _initializerDefineProperty(this, "errorTexts", _descriptor2, this);
    _initializerDefineProperty(this, "form", _descriptor3, this);
    this.validation = validation;
    this.fieldsToValidate = fieldsToValidate;
  }
  fieldChange(key, value) {
    set(this.form, key, value);
  }
  clear() {
    this.form = {};
  }
  get isInvalidForm() {
    return !!this.formErrorResponse.form;
  }
  get errors() {
    let _this = this;
    return keys(this.form).map(key => ({
      key,
      value: fieldValidating(_this.validation[key], _this.form[key], _this.errorTexts, _this.form)
    })).reduce((acc, curr) => {
      acc[curr.key] = curr.value;
      return acc;
    }, {});
  }
  get formValidated() {
    const errorsArray = Object.values(this.errors);
    const isValidForm = errorsArray.every(val => val === undefined || typeof val !== 'string');
    return keys(this.form).length >= this.fieldsToValidate && isValidForm;
  }
  get errorsNumber() {
    const errorsArray = Object.values(this.errors);
    const newErrorsArray = errorsArray.filter(val => val !== undefined);
    return newErrorsArray.length;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "formErrorResponse", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errorTexts", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "form", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "isInvalidForm", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isInvalidForm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formValidated", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "formValidated"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errorsNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errorsNumber"), _class.prototype), _class);
export default FormStore;